angular.module('app').directive('filtroCampanhasPoliticas', function() {
	return {
        restrict: 'E',
        templateUrl: '/html/filtro-campanhas-politicas.html?v='+angular.element('meta[name="version-id"]').attr('content'), 
        controller: function($scope) {

            $scope.initFiltro = function(){
                            
                var u = new URI();
                var query = u.search(true);
                var filtro = angular.fromJson(query.filtro);
                
                if(filtro){
                    $scope.ngModel = {
                        'nome': filtro.nome ? filtro.nome : '',
                        'uf': filtro.uf ? filtro.uf : '',
                        'municipio_id': filtro.municipio_id ? filtro.municipio_id : '',
                        'cargo_id': filtro.cargo_id ? filtro.cargo_id : '',
                        'partido_id': filtro.partido_id ? filtro.partido_id : ''
                    };
                }else{
                    $scope.ngModel = {};
                }
            };

            $scope.filtrar = function($event){
                $event.preventDefault();

                var base = window.location.protocol+'//'+window.location.hostname;
                
                var u = new URI(base+'/campanhas');

                u.removeSearch('filtro');
                u.addSearch({
                    filtro: angular.toJson($scope.ngModel)
                });

                window.location.href = u.toString();
            };
        },
        link: function ($scope) {
            $scope.initFiltro();
        }
    };
});